import {createSelector} from "reselect";

export const conditionSelector = (state) => state.condition;

export const productMapSelector = (state) => state.product;
export const productSelector = createSelector(
  productMapSelector,
  (product) => product
);

export const designsSelector = (state) => state.designs;

export const sidesSelector = (state) => state.sides;

export const pathSelector = (state) => state.path;
export const variantsSelector = (state) => state.condition.variants;
export const realismSelector = (state) => state.realism;
export const messageSelector = (state) => state.message;
export const picturesSelector = (state) => state.pictures;
export const uploaderSelector = (state) => state.uploader;

export const modalsMapSelector = (state) => state.modals;
export const modalSelector = (state, modal) => state.modals[modal];

export const undoRedoSelector = (state) => state.undoRedo;

export const isShownProductsSelector = (state) => state.isShownProducts;

export const cropsSelector = (state) => state.crops;

export const forAllSidesSelector = (state) => state.forAllSides;

export const isPichshopSelector = (state) => state.isPichshop;

export const figuresSelector = (state) => state.figures;
export const emojiSelector = (state) => state.emoji;

export const clipartsSelector = (state) => state.cliparts;

export const letteringsSelector = (state) => state.letterings;

export const initialVariantsSelector = (state) => state.initialVariants;

export const userSelector = (state) => state.user;

export const visionHubStateSelector = (state) => state.visionHubState;

export const onPlatformSelector = (state) => state.onPlatform;

export const shutterStockEnabledSelector = (state) => state.shutterStockEnabled;

export const mobileAppSelector = (state) => state.mobileApp;

export const drawControlPopupSelector = (state) => state.drawControlPopup;
